import {Component, OnInit} from '@angular/core';
import {FileEntry} from '@app/core/models/fileEntry.model';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {getUniqueListBy} from '@app/core/helpers';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {GetFileEntries} from '@app/core/store/actions/file-entry.actions';
import {Observable} from 'rxjs';
import {
	selectFileEntries,
	selectFileEntryIsLoading,
	selectFileEntryPagination
} from '@app/core/store/selectors/file-entry.selectors';
import {IQOPagination} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-pagination.interface';

@Component({
	selector: 'app-media-library',
	templateUrl: './media-library.component.html',
	styleUrls: ['./media-library.component.scss'],
})
export class MediaLibraryComponent implements OnInit {
	public fileEntries$: Observable<FileEntry[]> = this.store.select(selectFileEntries);
	public pagination$: Observable<IQOPagination> = this.store.select(selectFileEntryPagination);
	public isLoading$: Observable<boolean> = this.store.select(selectFileEntryIsLoading);

	public selectedIndex: number = 1;
	public selectedFilesIndex: number = 1;
	public uploadedFiles: FileEntry[] = [];
	public selectedFiles: FileEntry[] = [];

	constructor(
		private store: Store<IAppState>,
		public dialog: MatDialogRef<any>,
	) {
	}

	public ngOnInit(): void {
	}

	public rightClicked(): void {
		this.selectedIndex = 2;
		this.getFiles(this.selectedFilesIndex === 2);
	}

	public addFiles(files: FileEntry[]): void {
		this.uploadedFiles = getUniqueListBy([...this.uploadedFiles, ...files], 'id');
	}

	public paginate(page: number): void {
		this.getFiles(this.selectedFilesIndex === 2, page);
	}

	public fileSelected(file: FileEntry): void {
		this.selectedFiles.push(file);
	}

	public fileDeselected(file: FileEntry): void {
		this.selectedFiles = this.selectedFiles.filter(f => f.id !== file.id);
		this.uploadedFiles = this.uploadedFiles.filter(f => f.id !== file.id);
	}

	public save(): void {
		this.dialog.close(getUniqueListBy([...this.uploadedFiles, ...this.selectedFiles], 'id'));
	}

	public getFiles(isNotAttached: boolean, page = 1): void {
		this.store.dispatch(new GetFileEntries(page, 5, isNotAttached));
	}
}
